// Hard limits on render-job metadata computed from (untrusted) input props, so a
// malformed or malicious payload cannot request an absurd frame rate or a
// multi-hour render.
export const MIN_FPS = 24;
export const MAX_FPS = 60;
export const MAX_DURATION_SECONDS = 180;

export function clampFps(value, fallback = 30) {
  const fps = Number(value);
  const resolved = Number.isFinite(fps) && fps > 0 ? fps : fallback;
  return Math.min(MAX_FPS, Math.max(MIN_FPS, Math.round(resolved)));
}

export function clampDurationInFrames(durationInFrames, fps) {
  const frames = Math.ceil(Number(durationInFrames));
  const maxFrames = Math.floor(MAX_DURATION_SECONDS * fps);
  if (!Number.isFinite(frames) || frames < 1) return 1;
  return Math.min(maxFrames, frames);
}
